import CarouselSlider from "./carousel";
import Sermones from "./ultimosSermones";
import FooterContainer from "./footer/index";
import Test from "./test";

const Home = () => {
  return (
    <>
      <CarouselSlider />
      <Test />
      <Sermones />
      <FooterContainer />
    </>
  );
};

export default Home;
